module.exports = __webpack_public_path__ + "img/cooperate_8.3db90c29.png";